import { render, staticRenderFns } from "./TagsList.vue?vue&type=template&id=09b42d44&scoped=true&"
import script from "./TagsList.vue?vue&type=script&lang=js&"
export * from "./TagsList.vue?vue&type=script&lang=js&"
import style0 from "./TagsList.vue?vue&type=style&index=0&id=09b42d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b42d44",
  null
  
)

export default component.exports